import { useState, useMemo } from 'react';
import {
  AnsweredQuestionItem,
  DropdownItem,
  PageItem,
} from '../../Util/Form/formData.types';

/*
Each form has formState, but we can generalize in this hook
*/
export interface FormState {
  dropdownItems: DropdownItem[];
  questionsAnswered: Record<string, AnsweredQuestionItem>;
  pages: PageItem[];
  currentPage: number;
}

export const useFormState = (initialDropdowns: DropdownItem[] = []) => {
  const [state, setState] = useState<FormState>({
    dropdownItems: initialDropdowns,
    questionsAnswered: {},
    pages: [],
    currentPage: 0,
  });

  const updateDropdown = (type: string, selected: string) => {
    setState(prev => ({
      ...prev,
      dropdownItems: prev.dropdownItems.map(item =>
        item.type === type ? { ...item, selected } : item
      ),
    }));
  };

  const updateQuestion = (key: string, answer: AnsweredQuestionItem) => {
    setState(prev => ({
      ...prev,
      questionsAnswered: {
        ...prev.questionsAnswered,
        [key]: answer,
      },
    }));
  };

  const setDropdowns = (dropdowns: DropdownItem[]) => {
    setState(prev => ({ ...prev, dropdownItems: dropdowns }));
  };

  const setPages = (pages: PageItem[]) => {
    setState(prev => ({ ...prev, pages }));
  };

  return {
    state,
    updateDropdown,
    updateQuestion,
    setDropdowns,
    setPages,
  };
};
